import { ref } from 'vue';
import Sidebar from './Sidebar.vue';
import SidebarItem from './SidebarItem.vue';

// reactive()

const SidebarStore = {
  showSidebar: ref(false),
  sidebarLinks: ref([]),
  isMinimized: ref(false),
  
  displaySidebar(value) {
    this.showSidebar.value = value;
  },
  toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized.value = !this.isMinimized.value;
  },
};
const SidebarPlugin = {
  install(app, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }

    // app.mixin({
    //   data() {
    //     return {
    //       sidebarStore: SidebarStore,
    //     };
    //   },
    // });
    Object.defineProperty(app.config.globalProperties, '$sidebar', {
      get() {
        return SidebarStore;
      },
    });
    app.component('Sidebar', Sidebar);
    app.component('SidebarItem', SidebarItem);
    window.addEventListener('resize', () => {
      if (window.innerWidth < 992) { document.body.classList.remove('sidebar-mini'); }
    });
  },
};

export default SidebarPlugin;
